import axios, { Axios } from 'axios';

// const url = 'http://localhost:5000/posts';
// const urlh = 'http://localhost:5000/pages';
// const urlR = 'http://localhost:5000/messages';

const API = axios.create({baseURL:'https://saishreyas.herokuapp.com'})
// https://saishreyas.herokuapp.com
API.interceptors.request.use((req)=>{
    if(localStorage.getItem('profile')){
        req.headers.Autorization =`Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    }
return req;
});


export const fetchPosts = ()=> API.get('/posts'); 

// export const createPost = (newPost) => axios.post(url,newPost);
export const createPost = (newPost) => API.post('/posts',newPost);



// export const fetchHomepagePosts = ()=> axios.get(urlh); 
export const fetchHomepagePosts = ()=> API.get('/pages');

// export const createHomePagePosts = (newPagePost) => axios.post(urlh,newPagePost);
export const createHomePagePosts = (newPagePost) => API.post('/pages',newPagePost);


// export const fetchReviews = ()=> axios.get(urlR);
export const fetchReviews = ()=> API.get('/messages');

// export const createReviews = (reviews)=> axios.post(urlR,reviews);
export const createReviews = (reviews)=> API.post('messages',reviews);

// export const deleteReview = (id) => axios.delete(`${urlR}/${id}`);
export const deleteReview = (id) => API.delete(`${'messages'}/${id}`);


export const signIn = (formData1) => API.post('user/signinuser',formData1);
export const signUp = (formData1) => API.post('user/signupuser',formData1);